<template>
  <div v-if="message" class="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
    <div class="flex">
      <div class="flex-shrink-0">
        <div class="w-5 h-5 bg-red-400 rounded-full flex items-center justify-center">
          <span class="text-white text-xs font-bold">!</span>
        </div>
      </div>
      <div class="ml-3">
        <h3 class="text-sm font-medium text-red-800">
          {{ title || 'Error' }}
        </h3>
        <div class="mt-2 text-sm text-red-700">
          <p>{{ message }}</p>
        </div>
        <div v-if="details" class="mt-2">
          <details class="text-xs text-red-600">
            <summary class="cursor-pointer hover:text-red-800">Show details</summary>
            <pre class="mt-2 bg-red-100 p-2 rounded text-xs overflow-auto">{{ details }}</pre>
          </details>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  message?: string;
  title?: string;
  details?: string;
}

defineProps<Props>();
</script>
